<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import { useMapStore } from '@/stores/mapStore.ts'

const mapStore = useMapStore()

const mouseX = ref(0)
const mouseY = ref(0)

function updateMousePosition(event: MouseEvent) {
  mouseX.value = event.clientX
  mouseY.value = event.clientY
}

onMounted(() => {
  window.addEventListener('mousemove', updateMousePosition)
})

onUnmounted(() => {
  window.removeEventListener('mousemove', updateMousePosition)
})
</script>

<template>
  <div
    v-show="mapStore.routeTooltipVisible"
    :style="{
      left: mouseX + 15 + 'px',
      top: mouseY + 20 + 'px'
    }"
    class="tooltip bg-gray-900 z-50 px-2 py-1 rounded text-sm text-amber-400 pointer-events-none"
  >
    {{ mapStore.routeTooltipName }}
  </div>
</template>

<style scoped lang="scss">
.tooltip {
  position: fixed;
  white-space: nowrap;
}
</style>
